<table>
    <tr>
        <td scope="row" class="pl-2">{{title}}</td>
        <td class="col-md-4 col-sm-2 p-1" rowspan="2">
            <div class="form-group text-center justify-content-center mb-0">
                <input type="number" class="form-control form-control-sm" name="{{title}}" ngModel pattern="[0-9]"
                (keyup)="valueChanged($event)" placeholder="{{value}}" min="0">
            </div>  
        </td>
    </tr>
</table>